// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"23becc99","95":"521125be","312":"862c60f7","374":"c5ff962e","489":"ac952339","697":"51973422","906":"ebbd196a"}[chunkId] + ".chunk.js";
};